<div class="checkout-section d-lg-flex d-none">
    <div class="checkout-left">
        <div class="checkout-logo">
            <a routerLink="/home-page" class="c-logo">
                <img src="assets/images/new-logo.svg" alt="logo" />
            </a>
            <ul class="stepper-details">
                <li><a>Order Details <img src="assets/images/right-arrow-checkout.svg" alt="arrow" /></a></li>
                <li><a>Address <img *ngIf="newPay" src="assets/images/right-arrow-checkout.svg" alt="arrow" /></a></li>
                <li><a class="bg-opacity-white">Payment</a></li>
            </ul>
            <ng-container *ngIf="!newPay && mAddressListResponse && mAddressListResponse.data.length > 0">
                <div class="set-scroll-address" *ngIf="fullAddressArray && fullAddressArray.length>0">
                    <div class="checkout-address-detail" *ngFor="let address of fullAddressArray">
                        <div class="c-address-d-left">
                            <div class="c-title">
                                <div class="radio">
                                    <input [id]="'radio-'+address?.id" name="radio" type="radio"
                                        [checked]="address?.id == selectedAddress?.id"
                                        (change)="addressChange(address)">

                                    <label [for]="'radio-'+address?.id" class="radio-label"></label>
                                </div>
                                <h4>{{address?.name}}</h4>
                                <small *ngIf="address?.is_default" class="label-btn">Default</small>
                            </div>
                            <div class="address-detail">
                                <div class="a-icon" *ngIf="address?.id == selectedAddress?.id">
                                    <img src="assets/images/checkout-address-icon.svg" alt="icon" />
                                </div>
                                <div class="a-icon" *ngIf="address?.id != selectedAddress?.id">
                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                </div>
                                <div class="c-address-right-detail">
                                    <address>{{address?.address_line1}}, {{address?.city}},{{address?.state_name}},
                                        {{address?.postal_code}} </address>
                                    <span>{{address?.city}} - {{address?.postal_code}}</span>
                                    <div class="c-number">{{address?.contact_number1}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="c-address-edit">
                            <a data-bs-toggle="modal" data-bs-target="#add-update" type="button"
                                (click)="addUpdateAddress('edit',address)">
                                <img src="assets/images/edit-address.svg" alt="address" />
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ul class="btn-new-and-process" *ngIf="!newPay">
                <li><a class="new-address" data-bs-toggle="modal" data-bs-target="#add-update" type="button"
                        (click)="addUpdateAddress('add')">+ New Address</a></li>
                <li [ngClass]="selectedAddress?'' :'disabled'"><a class="proceed-to-pay"
                        (click)="clickPay('pay')">Proceed
                        to pay</a></li>
            </ul>
            <ul class="footer-link">
                <li><a routerLink="/terms-of-service">T&C</a></li>
                <li><a routerLink="/privacy-policy">Privacy</a></li>
                <li><a routerLink="/shipping-policy">Shipping & Returns</a></li>
            </ul>
        </div>
        <div class="orange" *ngIf="newPay">
            <div class="payment-detail-s">
                <div class="shipping-detail">
                    <div class="shipping-price">
                        <span>Subtotal ({{totalItems}} items)</span>
                        <span class="price">₹{{discountId && !showDiscountOnTotal ? calculateTotalAmount() : subTotalAmount}}</span>
                    </div>
                    <div *ngIf="discountAmount > 0" class="shipping-price">
                        <span>discount</span>
                        <span class="price"><small>(-)</small>₹{{discountAmount}}</span>
                    </div>
                    <div class="shipping-price">
                        <span>shipping charges</span>
                        <span class="price">₹{{shippingCharge}}</span>
                    </div>
                    <div class="shipping-price">
                        <span>Total</span>
                        <div>
                            <span class="price">₹{{discountId ? calculateTotalAmount(): totalAmountWithoutDiscount}}</span>
                        </div>
                    </div>
                </div>
                <div class="orange-detail">
                    <div class="orange-detail-text">
                        <div class="method-list mt-3">
                            <span class="mb-2">Please select payment method to complete the order</span>
                            <div class="price mt-0 mb-4">₹{{calculateTotalAmount()}}</div>
                            <div class="radio mb-2" (click)="choosePaymentType('justpay')">
                                <input id="radio-1" name="radio" type="radio" [checked]="paymentType == 'justpay'">
                                <label for="radio-1" class="radio-label">PAY ONLINE</label>
                                <div class="payment-icon">
                                    <ul>
                                        <li> <img src="assets/images/payment-1.svg" alt="icon"></li>
                                        <li> <img src="assets/images/payment-2.svg" alt="icon"></li>
                                        <li> <img src="assets/images/payment-3.svg" alt="icon"></li>
                                        <li> <img src="assets/images/payment-4.svg" alt="icon"></li>
                                        <li> <img src="assets/images/payment-5.svg" alt="icon"></li>
                                        <li> <img src="assets/images/payment-6.svg" alt="icon"></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="radio" (click)="choosePaymentType('cod')">
                                <input id="radio-2" name="radio" type="radio" [checked]="paymentType == 'cod'">
                                <label for="radio-2" class="radio-label">PAY ON DELIVERY</label>
                                <span class="payment-icon"><img src="assets/images/cash-on-delivery.svg" alt=""></span>
                            </div>
                        </div>
                    </div>
                    <div class="p-address-btn mt-4">
                        <button (click)="placeOrder()"[ngClass]="{'no-pointer-events': isLoadingPay, '': !isLoadingPay}">
                            <i *ngIf="isLoadingPay" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoadingPay, '': !isLoadingPay}"></i>
                            Proceed to pay</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="checkout-right scrollbar">
        <div class="cart-detail">
            <div class="cart-right-detail" *ngIf="!offers">
                <div class="cart-title">
                    <h4>Your Cart <img src="assets/images/checkout-cart.svg" alt="cart"></h4>
                </div>
                <div class="free-shipping" *ngIf="subTotalAmount < 499 && subTotalAmount > 0">You are ₹{{cartAmount}}
                    away from <b>free shipping!</b></div>
                <div class="free-shipping" *ngIf="subTotalAmount>= 499">You are eligible for <b>free shipping!</b></div>
                <div class="d-address">
                    <div class="d-left-address">
                        <div class="d-icon">
                            <img src="assets/images/delivery-checkout.svg" alt="delivery">
                        </div>
                        <div class="delivery-address">
                            <span>Delivery to {{selectedAddress?.postal_code}} </span>
                            <address *ngIf="selectedAddress">{{selectedAddress?.address_line1}},
                                {{selectedAddress?.city}}
                                ,{{selectedAddress?.state_name}} </address>
                        </div>
                    </div>
                    <div class="d-right-address">
                        <a (click)="changeAddress()">Change</a>
                    </div>
                </div>
                <ng-container
                    *ngIf="mAddUpdateCartModuleResponse.data &&  mAddUpdateCartModuleResponse.data.length > 0">
                    <div class="p-delivery-box"
                        *ngFor="let product of mAddUpdateCartModuleResponse.data; let i = index" [ngClass]="{'no-pointer-events': product?.productdetail.isLoading, '': !product?.productdetail.isLoading}">

                        <i *ngIf="product?.productdetail.isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner new-spinner': product?.productdetail.isLoading, '': !product?.productdetail.isLoading}"></i>
                        <div class="product-delivery-box">
                            <div class="p-left-box-content">
                                <div class="p-img">
                                    <img [src]="product?.productdetail?.imageList && product?.productdetail?.imageList.length > 0 && product?.productdetail?.imageList[0]?.path ? product?.productdetail.imageList[0].path : 'assets/images/default-product.png'"
                                        alt="product image">
                                </div>
                                <div class="p-img-content">
                                    <a>{{product?.productdetail?.brand?.name}}</a>
                                    <h4>{{product?.productdetail?.name}}</h4>
                                    <div class="p-size">Size: {{product?.productdetail?.size}}</div>
                                    <div class="p-quality">Quantity:</div>
                                    <div class="q-wrap">
                                        <button [disabled]="showDelete && product?.qty <=1" type="button" id="sub" class="q-sub"
                                            (click)="removeCartItem(product , i)">-</button>
                                        <input class="q-count" type="text" [value]="product?.qty" readonly />
                                        <button type="button" id="add" class="q-add"
                                            (click)="addCartItem(product , i)">+</button>
                                    </div>
                                </div>
                            </div>
                            <div class="p-right-box-content">
                                <a *ngIf="!showDelete"><img src="/assets/images/delete-checkout.svg" alt="delete"
                                        (click)="deleteCartItem(product , i)"></a>
                                <a *ngIf="!product.like" (click)="addInWishlist(product,'wishList')"><i
                                        class="fa-regular fa-heart set-color"></i></a>
                                <a *ngIf="product.like" (click)="addInWishlist(product,'wishList')"><i
                                        class="fa-solid fa-heart set-color"></i></a>
                            </div>
                        </div>
                        <div class="recomended-product">
                        </div>
                        <hr>
                        <div class="p-total">
                            <span>total</span>
                            <div class="total" *ngIf="!showDiscountOnTotal">
                                <span *ngIf="product?.discountAppliedAmount && product?.discountType == 'fix'">
                                    ₹{{product?.discountAppliedAmount}}</span>
                                <span *ngIf="product?.discountAppliedAmount && product?.discountType == 'percentage'">
                                    ₹{{product?.discountAppliedAmount}}</span>
                                <span
                                    [ngClass]="product?.discountAppliedAmount ? 'p-line-through' : ''">₹{{calculateIndividualTotal(product?.qty
                                    || 1, product?.productdetail?.your_price)}}</span>
                            </div>
                            <div class="total" *ngIf="showDiscountOnTotal">
                                <span>₹{{calculateIndividualTotal(product?.qty || 1,
                                    product?.productdetail?.your_price)}}</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="shipping-price">
                    <span>shipping charges</span>
                    <span class="price">₹{{shippingCharge}}</span>
                </div>
                <div class="shipping-price">
                    <span>Subtotal</span>
                    <span class="price">₹{{discountId && !showDiscountOnTotal ? calculateTotalAmount() : subTotalAmount}}</span>
                </div>
                <div class="shipping-price">
                    <span>Total</span>
                    <div>
                        <span class="price">₹{{discountId ? calculateTotalAmount() : totalAmountWithoutDiscount}}</span>
                    </div>
                </div>
                <div class="p-offer">
                    <a (click)="clickOffers('on')">
                        <div class="p-left-offer">
                            <div class="p-offer-image">
                                <img src="assets/images/offer-checkout.png" alt="offer">
                            </div>
                            <span>{{discountCode ? discountCode : 'Offers'}}</span>
                        </div>
                        <div class="p-right-offer">
                            <img src="assets/images/right-checkout.png" alt="arrow">
                        </div>
                    </a>
                </div>
                <div class="p-wishlist" *ngIf="wishlistData && wishlistData.length > 0">
                    <h4>Add from wishlist</h4>
                </div>
                
                <div class="row" *ngIf="wishlistData && wishlistData.length > 0">
                    <ng-container *ngFor="let wishList of wishlistData; let i = index">
                    <div class="col-lg-6 col-12" >
                        <app-product-box [color]="wishList?.productdetail?.category?.color" [product]="wishList"
                            [mAddUpdateCartModule]="mAddUpdateCartModule"
                            [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                            [mWishlistData]="wishlistData" [productType]="'wishlist'"></app-product-box>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div #content>
            <div class="offer-content" *ngIf="offers" >

                <div class="offer-title" (click)="clickOffers('off')">
                    <img src="/assets/images/profile-left-icon.svg" alt="icon">Offers
                </div>

                <div class="no-offer" *ngIf="discountList.length < 1">
                    <span>There are no offers currently</span>
                </div>
                <ng-container *ngIf="discountList && discountList.length > 0">
                    <div class="mb-3" *ngFor="let discount of discountList; let i = index">
                        <div class="coupon-box" [ngClass]="discount.discount_code == discountCode ? 'disable' : ''">
                            <div class="offer-code">
                                <span><img
                                        [src]="discount.discount_code == discountCode  ? 'assets/images/coupon-dark.png' : 'assets/images/coupon.png'"
                                        alt="coupon" /></span>
                            </div>
                            <div class="offer-code-all">
                                <div class="offer-code-left-side">
                                    <span>{{discount.discount_code}}</span>
                                    <small><b>{{discount.name}}</b></small>
                                    <small>
                                        <div class="cart-decription-text" [innerHTML]="discount?.description"></div>
                                    </small>
                                    <small class="save-text-color"
                                    *ngIf="discount.amount == 0 && (discount.max_amount > (subTotalAmount*discount.percentage / 100))">*save upto
                                    Rs. 
                                    {{subTotalAmount*discount.percentage / 100}} on this order!</small>
                                  <small class="save-text-color"
                                    *ngIf="discount.amount == 0 && (discount.max_amount < (subTotalAmount*discount.percentage / 100))">*save
                                    Rs.
                                    {{discount.max_amount}} on this order!</small>
                                    <small class="save-text-color" *ngIf="discount.amount > 0">*save Rs.
                                        {{discount.amount}} on this order!</small>
                                </div>
                                <div class="offer-code-Apply">
                                    <a *ngIf="discount.discount_code != discountCode"
                                        (click)="applyDiscount(discount.discount_code, false)"
                                        data-bs-dismiss="offcanvas">Apply</a>
                                    <a *ngIf="discount.discount_code == discountCode" (click)="removeDiscount()"
                                        data-bs-dismiss="offcanvas">Remove</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        </div>
    </div>
</div>

<!-- mobile section Start  -->


<section class="order-detail-section d-lg-none d-block" >
    <div class="smooth-scrolling" id="mainSectionMobile">

        <div class="m-stepper-detail"  *ngIf="!mobileOfferClick" >
            <div class="stepper-main-title">
                <h4 class="s-cart" *ngIf="cartAddress">Shopping Cart</h4>
                <h4 class="s-address" *ngIf="mobileAddress">Select Address</h4>
                <h4 class="p-detail" *ngIf="mobilePaymentClick">Payment Details</h4>
            </div>
            <ul class="step-content">
                <li class="m-c-pink">
                    <span>1</span>
                    <h4>Order Details</h4>
                    <small>Check your Order Details</small>
                </li>
                <li class="m-c-blue" [ngClass]="addAndSelectAddress?'m-c-blue-new':''">
                    <span>2</span>
                    <h4>Select Address</h4>
                    <small>Select a Delivery and Shipping Address</small>
                </li>
                <li class="m-c-orange" [ngClass]="addPaymentMethod?'m-c-orange-new':''">
                    <span>3</span>
                    <h4>Payment</h4>
                    <small>Process your payment</small>
                </li>
            </ul>
        </div>
        <div class="row" *ngIf="!mobileOfferClick">
            <div class="col-12">
                <div class="order-detail">
                    <div class="accordion" id="accordionExample">
                        <div class="accordion-item order" id="cart-accordion">
                            <h2 class="accordion-header" id="headingOne">
                                <button (click)="clickCart()" class="accordion-button order-detail-btn" [ngClass]="!showCart?'collapsed':''" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                    aria-controls="collapseOne">
                                    <div class="order-text">
                                        Order Details
                                        <span class="total-item">Total {{mAddUpdateCartModuleResponse.data &&
                                            mAddUpdateCartModuleResponse.data.length}} item(s)</span>
                                    </div>
                                    <div class="arrow-icon">
                                        <img src="assets/images/checkout-up.svg" alt="icon">
                                    </div>
                                </button>
                            </h2>
                            <div id="collapseOne" [ngClass]="showCart?'show':''" class="accordion-collapse collapse" aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample">
                                <div class="checkout-right scrollbar">
                                    <div class="cart-detail">
                                        <div class="cart-right-detail"
                                            *ngIf="mAddUpdateCartModuleResponse.data &&  mAddUpdateCartModuleResponse.data.length > 0">
                                            <div class="p-delivery-box"
                                                *ngFor="let product of mAddUpdateCartModuleResponse.data; let i = index">
                                                <div class="product-delivery-box">
                                                    <div class="p-left-box-content">
                                                        <div class="p-img">
                                                            <img [src]="product?.productdetail?.imageList && product?.productdetail?.imageList.length > 0 && product?.productdetail?.imageList[0]?.path ? product?.productdetail.imageList[0].path : 'assets/images/default-product.png'"
                                                                alt="cart-image" />
                                                        </div>
                                                        <div class="p-img-content">
                                                            <a>{{product?.productdetail?.brand?.name}}</a>
                                                            <h4>{{product?.productdetail?.name}}</h4>
                                                            <div class="p-size">Size: {{product?.productdetail?.size}}
                                                            </div>
                                                            <div class="p-quality">Quantity:</div>
                                                            <div class="q-wrap">
                                                                <button  [disabled]="showDelete && product?.qty <=1" type="button" id="sub" class="q-sub"
                                                                    (click)="removeCartItem(product , i)">-</button>
                                                                <input class="q-count" type="text"
                                                                    [value]="product?.qty" readonly />
                                                                <button type="button" id="add" class="q-add"
                                                                    (click)="addCartItem(product , i)">+</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="p-right-box-content">
                                                        <a *ngIf="!showDelete"><img src="/assets/images/delete-checkout.svg" alt="delete"
                                                                (click)="deleteCartItem(product , i)"></a>
                                                        <a *ngIf="!product.like"
                                                            (click)="addInWishlist(product,'wishList')"><i
                                                                class="fa-regular fa-heart set-color"></i></a>
                                                        <a *ngIf="product.like"
                                                            (click)="addInWishlist(product,'wishList')"><i
                                                                class="fa-solid fa-heart set-color"></i></a>
                                                    </div>
                                                </div>
                                                <div class="recomended-product">
                                                </div>
                                                <hr>
                                                <div class="p-total">
                                                    <span>total</span>
                                                    <div class="total" *ngIf="!showDiscountOnTotal">
                                                        <span
                                                            *ngIf="product?.discountAppliedAmount && product?.discountType == 'fix'">
                                                            ₹{{product?.discountAppliedAmount}}</span>
                                                        <span
                                                            *ngIf="product?.discountAppliedAmount && product?.discountType == 'percentage'">
                                                            ₹{{product?.discountAppliedAmount}}</span>
                                                        <span
                                                            [ngClass]="product?.discountAppliedAmount ? 'p-line-through' : ''">₹{{calculateIndividualTotal(product?.qty
                                                            || 1, product?.productdetail?.your_price)}}</span>
                                                    </div>
                                                    <div class="total" *ngIf="showDiscountOnTotal">
                                                        <span>₹{{calculateIndividualTotal(product?.qty || 1,
                                                            product?.productdetail?.your_price)}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="p-offer">
                                                <a (click)="offerClick(true)">
                                                    <div class="p-left-offer">
                                                        <div class="p-offer-image">
                                                            <img src="assets/images/offer-checkout.png" alt="offer">
                                                        </div>
                                                        <span>{{discountCode ? discountCode : 'Offers'}}</span>
                                                    </div>
                                                    <div class="p-right-offer">
                                                        <img src="assets/images/right-checkout.png" alt="arrow">
                                                    </div>
                                                </a>
                                            </div>
                                            <div class="shipping-detail">
                                                <div class="shipping-price">
                                                    <span>Subtotal ({{totalItems}} items)</span>
                                                    <span class="price">₹{{discountId && !showDiscountOnTotal ? calculateTotalAmount() : subTotalAmount}}</span>
                                                </div>
                                                <div *ngIf="discountAmount > 0" class="shipping-price">
                                                    <span>discount</span>
                                                    <span class="price"><small>(-)</small>₹{{discountAmount}}</span>
                                                </div>
                                                <div class="shipping-price">
                                                    <span>shipping charges</span>
                                                    <span class="price">₹{{shippingCharge}}</span>
                                                </div>
                                                <div class="shipping-price total">
                                                    <span>Total</span>
                                                    <div class="discount-price">
                                                        <span class="price">₹{{discountId ? calculateTotalAmount(): totalAmountWithoutDiscount}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="p-address-btn">
                                                <button (click)="mobilePayClick()">Proceed to Select Address</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item address" id="addressaccrodian">
                            <h2 class="accordion-header" id="headingTwo">
                                <button (click)="clickAddress()" [ngClass]="!showAddress?'collapsed':''" class="accordion-button order-detail-btn address-detail-btn"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                    aria-expanded="false" aria-controls="collapseTwo">
                                    Address
                                    <div class="arrow-icon">
                                        <img src="assets/images/checkout-up.svg" alt="icon">
                                    </div>
                                </button>
                            </h2>
                            <div [ngClass]="showAddress?'show':''" id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample">
                                <div class="user-profile-detail save-address-detail">
                                    <div class="address-modal-title check-address">
                                        <h4>Select an address</h4>
                                    </div>
                                    <div class="profile-my-address"
                                        *ngIf="fullAddressArray && fullAddressArray.length > 0">
                                        <div class="profile-scroll scrollbar"
                                            *ngFor="let address of fullAddressArray; let i = index">
                                            <div class="my-address-detail">
                                                <div class="left-address-detail">
                                                    <div class="name">
                                                        <div class="radio">
                                                            <input [id]="'radiomob-'+address?.id" name="radio1"
                                                                type="radio"
                                                                [checked]="address?.id == selectedAddress?.id"
                                                                (change)="addressChange(address)">
                                                            <label [for]="'radiomob-'+address?.id"
                                                                class="radio-label"></label>
                                                        </div>
                                                        <span>{{address?.name}}</span>
                                                        <label *ngIf="address?.is_default">Default</label>
                                                    </div>
                                                    <div class="delivery-d">
                                                        <div class="delivery-icon" *ngIf="address?.id == selectedAddress?.id">
                                                            <span><img src="assets/images/delivery-checkout-silver.svg" 
                                                                alt="icon"></span>
                                                        </div>
                                                        <div class="delivery-icon" *ngIf="address?.id != selectedAddress?.id">
                                                            <span>
                                                                &nbsp; &nbsp; &nbsp; &nbsp;
                                                            </span>
                                                        </div>
                                                        <div class="pincode-d">
                                                            <address>{{address?.address_line1}},
                                                                {{address?.city}},{{address?.state_name}},
                                                                {{address?.postal_code}} </address>
                                                            <div class="pincode">{{address?.postal_code}}</div>
                                                            <div class="address-call">{{address?.contact_number1}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="right-address-button">
                                                    <ul>
                                                        <li><a data-bs-toggle="modal"
                                                                (click)="addUpdateAddress('edit',address)"
                                                                data-bs-target="#add-update"><img
                                                                    src="assets/images/edit-address.svg"
                                                                    alt="address" /></a></li>
                                                        <li *ngIf="!address?.is_default"><a (click)="removeAddress(address.id)"><img
                                                                    src="/assets/images/delete-address.svg"
                                                                    alt="delete" /></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="add-new-address-btn">
                                        <button data-bs-toggle="modal" data-bs-target="#add-update  " type="button"
                                            (click)="addUpdateAddress('add')"><span><img
                                                    src="assets/images/add-new-address-plus.svg" alt="icon"></span> add
                                            new address</button>
                                    </div>
                                    <div class="p-address-btn">
                                        <button [ngClass]="selectedAddress?'' :'disabled'" (click)="mobileAddressClick()" [disabled]="!selectedAddress">Proceed to
                                            Payment Details</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item address pay-new" id="paymentView">
                            <h2 class="accordion-header" id="headingThree">
                                <button (click)="clickPayment()" [ngClass]="!showPayment?'collapsed':''" class="accordion-button order-detail-btn payment-btn" type="button" 
                                    data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false"
                                    aria-controls="collapseThree">
                                    Payment Details
                                    <div class="arrow-icon">
                                        <img src="assets/images/checkout-up.svg" alt="icon">
                                    </div>
                                </button>
                            </h2>
                            <div [ngClass]="showPayment?'show':''" id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample">
                                <div class="payment-detail-s">
                                    <div class="shipping-detail">
                                        <div class="shipping-price">
                                            <span>Subtotal ({{totalItems}} items)</span>
                                            <span class="price">₹{{discountId && !showDiscountOnTotal ? calculateTotalAmount() : subTotalAmount}}</span>
                                        </div>
                                        <div *ngIf="discountAmount > 0" class="shipping-price">
                                            <span>discount</span>
                                            <span class="price"><small>(-)</small>₹{{discountAmount}}</span>
                                        </div>
                                        <div class="shipping-price">
                                            <span>shipping charges</span>
                                            <span class="price">₹{{shippingCharge}}</span>
                                        </div>
                                        <div class="shipping-price">
                                            <span>Total</span>
                                            <div>
                                                <span class="price">₹{{discountId ? calculateTotalAmount(): totalAmountWithoutDiscount}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-offer">
                                        <a (click)="offerClick()">
                                            <div class="p-left-offer">
                                                <div class="p-offer-image">
                                                    <img src="assets/images/offer-checkout.png" alt="offer">
                                                </div>
                                                <span>{{discountCode ? discountCode : 'Offers'}}</span>
                                            </div>
                                            <div class="p-right-offer">
                                                <img src="assets/images/right-checkout.png" alt="arrow">
                                            </div>
                                        </a>
                                    </div>
                                    <div class="method-list mt-3">
                                        <span>Please select payment method to complete the order</span>
                                        <div class="radio mb-2" (click)="choosePaymentType('justpay')">
                                            <input id="radio-1" name="radio" type="radio"
                                                [checked]="paymentType == 'justpay'">
                                            <label for="radio-1" class="radio-label">PAY ONLINE</label>
                                            <div class="payment-icon">
                                                <ul>
                                                    <li> <img src="assets/images/payment-1.svg" alt="icon">
                                                    </li>
                                                    <li> <img src="assets/images/payment-2.svg" alt="icon">
                                                    </li>
                                                    <li> <img src="assets/images/payment-3.svg" alt="icon">
                                                    </li>
                                                    <li> <img src="assets/images/payment-4.svg" alt="icon">
                                                    </li>
                                                    <li> <img src="assets/images/payment-5.svg" alt="icon">
                                                    </li>
                                                    <li> <img src="assets/images/payment-6.svg" alt="icon">
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="radio" (click)="choosePaymentType('cod')">
                                            <input id="radio-2" name="radio" type="radio"
                                                [checked]="paymentType == 'cod'">
                                            <label for="radio-2" class="radio-label">PAY ON DELIVERY</label>
                                            <span class="payment-icon"><img class="cash-icon"
                                                    src="assets/images/cash-on-delivery.svg" alt=""></span>
                                        </div>
                                    </div>
                                    <div class="p-address-btn">
                                        <button [ngClass]="selectedAddress?'' :'disabled'" [disabled]="!selectedAddress" (click)="placeOrder()" [ngClass]="{'no-pointer-events': isLoadingPay, '': !isLoadingPay}">
                                            <i *ngIf="isLoadingPay" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoadingPay, '': !isLoadingPay}"></i>
                                            Proceed to pay</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" *ngIf="wishlistData && wishlistData.length > 0">
                <div class="p-wishlist">
                    <h4>Add from wishlist</h4>
                </div>
                <div class="row p-2">
                    <ng-container *ngFor="let wishList of wishlistData; let i = index">
                    <div class="col-6 mb-4 mt-4 item"  >
                        <app-product-box [color]="wishList?.productdetail?.category?.color" [product]="wishList"
                            [mAddUpdateCartModule]="mAddUpdateCartModule"
                            [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                            [mWishlistData]="wishlistData" [productType]="'wishlist'" (addToCartBuyNow)="addToCartBuyNow($event)"></app-product-box>
                            
                    </div>
                </ng-container>
                </div>
                <div class="row p-2" *ngIf="mWishlistData.length < 1">
                    <div class="empty-card-new">
                        <div class="empty-card">
                            <div class="empty-card-icon">
                                <img src="assets/images/wishlist-empty.svg" alt="icon">
                            </div>
                            <span>No items in your wishlist</span>
                            <small>Add items to wishlist now!</small>
                        </div>
                        <a routerLink="/shop-all" class="start-btn">Add items to wishlist</a>
                    </div>
                </div>
            </div>
        </div>
        <section class="offer-mobile-section" *ngIf="mobileOfferClick" id="offersView1">
            <div class="row justify-content-center">
                <div class="col-sm-9 col-12">
                    <div class="offer-content">

                        <div class="offer-title" (click)="backOfferClick()">
                            <img src="/assets/images/profile-left-icon.svg" alt="icon">Offers
                        </div>

                        <div class="no-offer" *ngIf="discountList.length < 1">
                            <span>There are no offers currently</span>
                        </div>
                        <ng-container *ngIf="discountList && discountList.length > 0">
                            <div class="mb-3" *ngFor="let discount of discountList; let i = index">
                                <div class="coupon-box"
                                    [ngClass]="discount.discount_code == discountCode ? 'disable' : ''">
                                    <div class="offer-code">
                                        <span><img
                                                [src]="discount.discount_code == discountCode  ? 'assets/images/coupon-dark.png' : 'assets/images/coupon.png'"
                                                alt="coupon" /></span>
                                    </div>
                                    <div class="offer-code-all">
                                        <div class="offer-code-left-side">
                                            <span>{{discount.discount_code}}</span>
                                            <small><b>{{discount.name}}</b></small>
                                            <small>
                                                <div class="cart-decription-text" [innerHTML]="discount?.description"></div>
                                            </small>
                                            <small class="save-text-color"
                                                *ngIf="discount.amount == 0 && (discount.max_amount > (subTotalAmount*discount.percentage / 100))">*save upto
                                                Rs. 
                                                {{subTotalAmount*discount.percentage / 100}} on this order!</small>
                                                <small class="save-text-color"
                                                *ngIf="discount.amount == 0 && (discount.max_amount < (subTotalAmount*discount.percentage / 100))">*save
                                                Rs.
                                                {{discount.max_amount}} on this order!</small>
                                            <small class="save-text-color" *ngIf="discount.amount > 0">*save Rs.
                                                {{discount.amount}} on this order!</small>
                                        </div>
                                        <div class="offer-code-Apply">
                                            <a *ngIf="discount.discount_code != discountCode"
                                                (click)="applyDiscount(discount.discount_code,false)"
                                                data-bs-dismiss="offcanvas">Apply</a>
                                            <a *ngIf="discount.discount_code == discountCode" (click)="removeDiscount()"
                                                data-bs-dismiss="offcanvas">Remove</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <app-footer-bg class="d-lg-none d-block"></app-footer-bg>
</section>





<!-- mobile section End  -->


<div class="modal fade" id="add-update" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="add-new-address-model">
        <app-add-address [addressData]="addressData" [viewForm]="viewForm" [from]="'checkout'"
            (saveClickCheckout)="saveNewAddress($event)"></app-add-address>
    </div>
</div>

<div class="modal fade new-email-popup-d" id="email-update" tabindex="-1" aria-labelledby="emailModalLabel" aria-hidden="true">
    <div class="add-new-address-model">
        <div class="modal-dialog" >
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-header py-0 d-lg-flex d-none   justify-content-end">
                        <button class="modal-button" type="button" data-bs-dismiss="modal" aria-label="Close"><img src="/assets/images/close-icon.png" alt="close" (click)="closeModal()"></button>
                    </div>
                    <div class="address-modal-title address-email-text">
                        <h4>Email</h4>
                    </div>
                    <form class="add-new-address-detail" [formGroup]="emailFormgroup" (ngSubmit)="onSubmitEmail()">
                       
                        <div class="add-new-address-detail-input row">
                           
                            <div class="mb-3 col-lg-12 col-md-12 email-text">
                                <label>Email</label>
                                <input type="email" formControlName="email" placeholder="Email">
                                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger alert-text">
                                    <div *ngIf="f['email'].errors && f['email'].errors['required']">Email is
                                      required.</div>
                                    <div *ngIf="f['email'].hasError('pattern')">
                                      Email is invalid.
                                    </div>
                                  </div>
                            </div>
                            <ul class="save-and-close new-save-btn d-lg-block d-none">
                                <li><button type="submit" class="save-dark" >Save Details</button></li>
                            </ul>
                        </div>
                        <ul class="save-and-close d-lg-none d-flex">
                            <li><button type="submit" class="save-dark" >Save Details</button></li>
                            <li><button class="cancel-border" data-bs-dismiss="modal" 
                                (click)="closeModal();" aria-label="Close">Cancel</button></li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>